import { Button, Typography } from '@mui/material';

import { Dialog } from 'uiKit/Dialog';
import { useIsSMDown } from 'uiKit/Theme/useTheme';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import cover from './assets/cover.webp';
import { freemiumWelcomeDialogTranslation } from './translation';
import { useFreemiumWelcomeDialog } from './hooks/useFreemiumWelcomeDialog';
import { useFreemiumWelcomeDialogStyles } from './useFreemiumWelcomeDialogStyles';

export const FreemiumWelcomeDialog = () => {
  const { classes } = useFreemiumWelcomeDialogStyles();

  const { keys, t } = useTranslation(freemiumWelcomeDialogTranslation);

  const { handleClose, isOpen } = useFreemiumWelcomeDialog();

  const isSMDown = useIsSMDown();

  const [buttonSize, textVariant] = isSMDown
    ? (['small', 'body3'] as const)
    : (['large', 'body2'] as const);

  return (
    <Dialog
      classes={classes}
      closeButtonClassName={classes.closeButton}
      onClose={handleClose}
      open={isOpen}
      title={<img alt="Top cover" src={cover} width="100%" />}
      titleClassName={classes.dialogTitle}
    >
      <Typography color="textPrimary" sx={{ mb: 3 }} variant="h6">
        {t(keys.title)}
      </Typography>
      <Typography
        component="div"
        color="textPrimary"
        sx={{ mb: { xxs: 5, sm: 6 } }}
        variant={textVariant}
      >
        {t(keys.description)}
      </Typography>
      <Button
        fullWidth
        onClick={handleClose}
        size={buttonSize}
        sx={{ mb: { xxs: 5, sm: 6 } }}
        variant="contained"
      >
        {t(keys.doneButton)}
      </Button>
      <Typography
        color="textSecondary"
        sx={{ display: 'flex', justifyContent: 'center', textAlign: 'center' }}
        variant={textVariant}
      >
        {t(keys.note)}
      </Typography>
    </Dialog>
  );
};
